import { FC } from 'react';

const SpinnerArrow: FC<{
  borderColor: string;
  bgColor: string;
}> = ({ borderColor, bgColor }) => (
  <svg
    width="36"
    height="33"
    viewBox="0 0 36 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.13641 2.2267L1.48623 2.60055L1.86007 3.25073L17.1948 29.9206L17.8426 31.0473L18.4939 29.9226L33.9122 3.30096L34.288 2.65196L33.639 2.27607C30.8954 0.687049 28.0124 2.02187 25.4672 3.41141C25.0876 3.61868 24.7134 3.82872 24.3423 4.03702C23.4078 4.56157 22.493 5.07505 21.5603 5.50537C20.2684 6.10134 19.0377 6.48887 17.8461 6.48701C16.6549 6.48514 15.43 6.09395 14.1473 5.49434C13.2188 5.06034 12.3096 4.54286 11.3808 4.01421C11.0149 3.80594 10.6459 3.59594 10.2715 3.38863C7.74706 1.99073 4.88583 0.645821 2.13641 2.2267Z"
      fill={bgColor}
      stroke={borderColor}
      strokeWidth="1.5"
    />
  </svg>
);

export default SpinnerArrow;
